<h1 mat-dialog-title>Apparaat koppelen</h1>

<mat-dialog-content class="flex! flex-col relative">
  <mat-form-field
    subscriptSizing="dynamic"
    class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
  >
    <mat-icon matPrefix> search </mat-icon>

    <input
      #searchInput
      matInput
      placeholder="Zoeken op ID of naam..."
      [ngModel]="keyword()"
      (ngModelChange)="handleSearch(searchInput.value)"
    />

    @if (keyword()) {
      <button mat-icon-button matSuffix class="mr-1" (click)="clearSearch()">
        <mat-icon>cancel</mat-icon>
      </button>
    }
  </mat-form-field>

  <div class="pt-6 pb-2 text-sm font-medium">
    @let selected = selectedCount();

    @if (selected === 1) {
      1 apparaat geselecteerd
    } @else {
      {{ selected }} apparaten geselecteerd
    }
  </div>

  <div class="-mx-6 py-2 border-y border-gray-200 overflow-auto scrollbar-width-thin">
    <div class="flex flex-col gap-8 min-h-70">
      <div class="px-6">
        <mat-selection-list class="p-0!" [multiple]="multiple()" [disabled]="submitted()" (selectionChange)="handleSelectionChange()">
          @for (item of dataSource(); track $index) {
            <mat-list-option
              togglePosition="before"
              [value]="item"
              class="pl-2! select-none [--mdc-list-list-item-disabled-state-layer-color:transparent] [--mdc-list-list-item-hover-state-layer-color:var(--color-gray-200)] [--mdc-list-list-item-hover-state-layer-opacity:1] [--mdc-list-list-item-container-shape:var(--radius-lg)]"
            >
              <div class="grid grid-cols-2 gap-4">
                <div class="flex flex-auto text-sm">
                  @let item_label = item.label ? item.label : 'Geen naam';
                  <span
                    class="w-min max-w-40 truncate inline-block align-middle"
                    [matTooltip]="item_label"
                    matTooltipPosition="after"
                    >{{ item_label }}</span
                  >
                </div>
                <div class="text-xs text-gray-500">
                  {{ item.idAlias }} /
                  {{ item.type | mapFrom: deviceMap[item.category] }}
                </div>
              </div>
            </mat-list-option>
          } @empty {
            <p>Er zijn geen beschikbare apparaten om te koppelen.</p>
          }
        </mat-selection-list>

        @if (showLoadMore()) {
          <button
            mat-button
            (click)="loadMoreItems()"
            [disabled]="fetching()"
            class="w-full [--mdc-text-button-container-shape:var(--radius-lg)]"
          >
            Meer laden
          </button>
        }
      </div>
    </div>
  </div>
  @if (globalLoaders.isActive(loaderId)) {
    <div class="absolute top-0 left-0 w-[100%]">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button
    mat-button
    (click)="handleConfirm()"
    [disabled]="submitted() || !selection().selectedOptions.selected.length"
  >
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
